import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "du-economics-semester-wise-syllabus-reading-list-2026",
  category: "college-life",
  authorSlug: "dhairya-madaan",
  title: "DU B.A. (Hons) Economics Complete Semester-Wise Syllabus & Reading List 2026-27",
  description: "The comprehensive 8-semester structure under UGCF 2022 (NEP). Details for all Core, DSE, GE, SEC papers, including textbooks and exam patterns.",
  pubDate: "2026-08-20",
  tags: ["du-economics", "syllabus", "reading-list", "ugcf"],
  readMinutes: 14,
  heroEyebrow: "College Life · Syllabus",
};

export function Body() {
  return (
    <article className="max-w-4xl mx-auto space-y-8">
      <header className="mb-10">
        <h1 className="text-4xl font-bold mb-4 text-primary">DU B.A. (Hons) Economics Complete Semester-Wise Syllabus &amp; Reading List 2026-27</h1>
        <p className="text-xl text-muted-foreground">Navigate your 4-year degree under UGCF 2022 (NEP)</p>
      </header>

      <section>
        <p className="mb-4">The Undergraduate Curriculum Framework (UGCF) 2022 based on the National Education Policy (NEP) introduced a flexible 4-year degree structure. This guide breaks down the B.A. (Hons) Economics syllabus, semester by semester.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4 border-b border-rule pb-2">Semester 1</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-card text-left text-sm mb-6">
            <thead className="bg-muted text-muted-foreground">
              <tr>
                <th className="px-4 py-2 border border-rule">Paper Type</th>
                <th className="px-4 py-2 border border-rule">Subject Name</th>
                <th className="px-4 py-2 border border-rule">Credits</th>
                <th className="px-4 py-2 border border-rule">Key Textbooks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-4 py-2 border border-rule">Core 1</td>
                <td className="px-4 py-2 border border-rule">Introductory Microeconomics</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Mankiw, G.N., "Principles of Economics" (Latest Edition)</td>
              </tr>
              <tr>
                <td className="px-4 py-2 border border-rule">Core 2</td>
                <td className="px-4 py-2 border border-rule">Introductory Mathematical Methods for Economics</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Sydsaeter, K., Hammond, P., "Mathematics for Economic Analysis"</td>
              </tr>
              <tr>
                <td className="px-4 py-2 border border-rule">Core 3</td>
                <td className="px-4 py-2 border border-rule">Introductory Statistics for Economics</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Devore, J.L., "Probability and Statistics for Engineering and the Sciences"</td>
              </tr>
              <tr>
                <td className="px-4 py-2 border border-rule">GE 1</td>
                <td className="px-4 py-2 border border-rule">Generic Elective 1 (From other dept)</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Varies by choice</td>
              </tr>
            </tbody>
          </table>
          <p className="text-sm text-muted-foreground">Also includes: AEC 1 (Environmental Science/Language, 2 Credits), SEC 1 (Skill Enhancement, 2 Credits), VAC 1 (Value Addition, 2 Credits).</p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4 border-b border-rule pb-2">Semester 2</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-card text-left text-sm mb-6">
            <thead className="bg-muted text-muted-foreground">
              <tr>
                <th className="px-4 py-2 border border-rule">Paper Type</th>
                <th className="px-4 py-2 border border-rule">Subject Name</th>
                <th className="px-4 py-2 border border-rule">Credits</th>
                <th className="px-4 py-2 border border-rule">Key Textbooks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-4 py-2 border border-rule">Core 4</td>
                <td className="px-4 py-2 border border-rule">Introductory Macroeconomics</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Blanchard, O., "Macroeconomics"</td>
              </tr>
              <tr>
                <td className="px-4 py-2 border border-rule">Core 5</td>
                <td className="px-4 py-2 border border-rule">Intermediate Mathematical Methods for Economics</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Sydsaeter &amp; Hammond (Advanced Chapters)</td>
              </tr>
              <tr>
                <td className="px-4 py-2 border border-rule">Core 6</td>
                <td className="px-4 py-2 border border-rule">Intermediate Statistics for Economics</td>
                <td className="px-4 py-2 border border-rule">4</td>
                <td className="px-4 py-2 border border-rule">Larsen, R.J., Marx, M.L., "An Introduction to Mathematical Statistics"</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4 border-b border-rule pb-2">Semesters 3 &amp; 4 (Highlights)</h2>
        <p className="mb-2"><strong>Core Papers:</strong> Intermediate Microeconomics I &amp; II (Varian, H.R., "Intermediate Microeconomics"), Intermediate Macroeconomics I &amp; II (Dornbusch, Fischer, Startz), Introductory Econometrics (Wooldridge, J.M., "Introductory Econometrics").</p>
        <p>This is where the rigor peaks. Econometrics starts in Sem 4, bringing together Statistics and Economic Theory.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4 border-b border-rule pb-2">Semesters 5 &amp; 6 (Highlights)</h2>
        <p className="mb-2"><strong>Core Papers:</strong> Indian Economy I &amp; II (Misra &amp; Puri, Economic Survey of India), Development Economics I &amp; II (Todaro &amp; Smith, "Economic Development").</p>
        <p><strong>DSE (Discipline Specific Electives):</strong> Students typically choose 2 DSEs per semester. Popular options: International Trade, Public Economics, Financial Economics, Environmental Economics.</p>
      </section>
      
      <section>
        <h2 className="text-2xl font-bold mb-4 border-b border-rule pb-2">Semesters 7 &amp; 8 (4th Year Honours/Research)</h2>
        <p className="mb-4">Students continuing for the 4th year pursue advanced coursework and a dissertation (for the Research track). Advanced Econometrics, Applied Economics, and highly specialized DSEs are offered.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4 border-b border-rule pb-2">Exam Pattern (Theory vs IA)</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Theory Exam:</strong> 70 marks (or scaling equivalent). End-semester examination conducted by the university.</li>
          <li><strong>Internal Assessment (IA):</strong> 30 marks. Comprises class tests, assignments/presentations, and attendance. Continuous Evaluation (CE) components are heavily emphasized in NEP.</li>
          <li><strong>Practicals:</strong> Papers like Econometrics and Statistics may have practical components involving R/Stata/Python.</li>
        </ul>
      </section>
    </article>
  );
}


